import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ConfigService } from 'src/app/core/config/config.service';

@Component({
  selector: 'oops',
  templateUrl: './oops.component.html',
  styleUrls: ['./oops.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OopsComponent {
  public gotoMain(): void {
    location.href = `${ConfigService?.config?.CLIENT_ROOT}`;
  }
}
